global.$ = global.jQuery = require("jquery");
require("@rails/ujs").start();
require("./public/iframe_viewer_for_lp");

import '@fortawesome/fontawesome-free/css/all.css';
import '@fortawesome/fontawesome-free/js/all.js';

//追従アンカーリンク
if (window.matchMedia( "(max-width: 767px)" ).matches) {
  $(function(){
    var $flowcv = $('.flow-cv');

    $(window).scroll(function() {
      if($(this).scrollTop() > 1000 & $(this).scrollTop() < 11700) {
        $flowcv.fadeIn("300");
      } else {
        $flowcv.fadeOut("300");
      }
    });
  });
};
